import { UmbrellaLogo } from "@/components/UmbrellaLogo";
import { usePageMeta } from "@/lib/usePageMeta";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  usePageMeta("Sign in", "Sign in to Black Umbrella to post jobs, compare quotes, message businesses and manage payments.");
  const signIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between bg-slate-950 text-white p-12 relative overflow-hidden">
        <div className="flex items-center gap-2">
          <UmbrellaLogo size={32} />
          <span className="font-heading font-extrabold text-xl">Black Umbrella</span>
        </div>
        <div>
          <h1 className="font-heading text-4xl lg:text-5xl font-extrabold leading-tight text-balance">
            Coverage, protection, and shelter for the community.
          </h1>
          <p className="mt-4 text-slate-400 text-lg max-w-md">
            Find, hire, and pay vetted Black-owned trades and businesses across Canada — with escrow, bonding, and verified insurance.
          </p>
        </div>
        <div className="flex gap-3 text-xs text-slate-500">
          <span>Vetted</span>·<span>Bonded</span>·<span>Insured</span>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center p-8">
        <div className="w-full max-w-sm text-center">
          <div className="lg:hidden flex items-center justify-center gap-2 mb-8">
            <UmbrellaLogo size={30} className="text-slate-950" />
            <span className="font-heading font-extrabold text-lg">Black Umbrella</span>
          </div>
          <h2 className="font-heading text-3xl font-bold text-slate-950">Welcome</h2>
          <p className="mt-2 text-slate-500">Sign in to hire trusted businesses or grow yours.</p>
          <Button data-testid="google-signin-button" onClick={signIn}
            className="mt-8 w-full h-12 bg-slate-950 hover:bg-amber-600 text-white rounded-full text-base font-semibold">
            Continue with Google
          </Button>
          <p className="mt-6 text-xs text-slate-400">
            By continuing you agree to Black Umbrella's <Link to="/terms" data-testid="login-terms-link" className="underline hover:text-amber-600">terms</Link>. Escrow payments in CAD via Stripe.
          </p>
        </div>
      </div>
    </div>
  );
}
